import moment from "moment";
import { orderBy } from "lodash";

export const formatDate = (date: moment.MomentInput): string => {
  return moment(date).format("MMM DD YYYY");
};
export const formattedMonth = (month: number): string => {
  return moment(month, "M").format("MMM");
};
export const customOrder = (
  obj: any,
  key: string,
  order: "asc" | "desc" | boolean = false
) => {
  return orderBy(
    obj,
    [
      (o) => {
        if (typeof o[key] === "number") {
          return o[key];
        }
        return o[key]?.toLowerCase();
      },
    ],
    order ? order : "desc"
  );
};
export const calculateT10andT100Diff = (t10: any, t100: any) => {
  const valT10 = parseInt(t10) || 0;
  const valT100 = parseInt(t100) || 0;
  if (valT10 === 0 || valT100 === 0) {
    return 0;
  }
  return ((valT10 - valT100) / valT100) * 100;
};
export const countWords = (text: string) => {
  const matches = text.match(/\S+/g);
  return matches ? matches.length : 0;
};
export const changeArrayObjectOrder = (
  arr: any,
  newOrder: any,
  orderProperty: string
) => {
  const idToIndexMap = {};
  arr.forEach((obj, index) => {
    const property = obj[orderProperty];
    idToIndexMap[property] = index;
  });
  const newArray = newOrder.map((o) => arr[idToIndexMap[o]]);
  return newArray;
};
